import { request } from "./request";
import { User } from "./types";

export const updateCurrentUser = async (name: string): Promise<User> => {
  const response = await request({
    path: "/api/v1/user-service/me",
    method: "PATCH",
    body: {
      name,
    },
  });

  if (response.ok) {
    return response.data?.user;
  }

  throw new Error(response.errorMessage);
};
